import store from 'store';
import sellerStore from 'store/indexSeller';
import {isCurrentAppSeller, isCurrentAppDefault} from 'utils/appTypeState';

function getApiAuthToken () {
  if (isCurrentAppSeller()) {
    return sellerStore.getters['sellerCommon/authToken'];
  } else if (isCurrentAppDefault()) {
    return store.getters['common/authToken'];
  }
}

export default getApiAuthToken;
